module.exports = __webpack_public_path__ + "img/choose-contact.83eeacfa.svg";